<template>
	<div class="yzsdglfw-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{youshiInfo.title || ''}}</div>
				<div class="des">提供涵盖集装箱产品碳足迹“核算”“核查”“披露”“查询”的全链条集成服务</div>
<!-- 				<div class="des">{{youshiInfo.des || ''}}</div> -->
			</div>
		</div>
		<!-- 全流程一体化服务 -->
		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-1">
				<div class="section-container w1260">
					<div class="heading">全流程一体化服务</div>
					<!-- <div class="des">一站式管理服务是该平台的核心竞争力，通过 以下六条全链条一体化服务，为企业提供碳足迹管理闭环解决方案。</div> -->
					<div class="ul">
						<div class="li">
							<div class="square"></div>
							<div class="label">核算</div>
						</div>
						<div class="li">
							<div class="square"></div>
							<div class="label">报告</div>
						</div>
						<div class="li">
							<div class="square"></div>
							<div class="label">认证</div>
						</div>
						<div class="li">
							<div class="square"></div>
							<div class="label">标识</div>
						</div>
						<div class="li">
							<div class="square"></div>
							<div class="label">评价</div>
						</div>
						<div class="li">
							<div class="square"></div>
							<div class="label">披露</div>
						</div>
						<div class="li">
							<div class="square"></div>
							<div class="label">查询</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 多主体高效协同 -->
		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-4">
				<div class="section-container w1260">
					<div class="heading">多主体高效协同</div>
					<div class="section-pic">
						<img class="img" src="@/assets/svgs/xietong.svg" alt="" />
					</div>
				</div>
			</div>
		</div>
		<!-- 技术赋能的精准管理 -->
		<!-- <div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-2">
				<div class="section-container w1260">
					<div class="heading">全流程一体化服务</div>
					<div class="ul">
						<div class="li">
							<div class="provide">为企业提供</div>
							<div class="label">"三库一模型" 数据支撑</div>
							<div class="des">全行业最全面的碳核算基础数据。内置国内外权威排放因子数据库，支持数据灵活查询和调用，确保计算结果科学准确</div>
						</div>
						<div class="li">
							<div class="provide">为企业提供</div>
							<div class="label">多维分析与预警</div>
							<div class="des">供碳排放趋势分析、同行业对标和减排潜力评估，自动预警超标排放，辅助企业制定科学的碳管理策略</div>
						</div>
						<div class="li">
							<div class="provide">为企业提供</div>
							<div class="label">全链路碳足迹可视化</div>
							<div class="des">通过数字孪生技术，实现集装箱从原材料采购、生产制造到运输、使用、报废全生命周期碳排放的动态可视化展示，帮助企业精准识别 "碳热点"</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- 构建行业碳标准体系 -->
		<!-- <div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-3">
				<div class="section-container w1260">
					<div class="left-block scale-img">
						<div class="cover over-hidden">
							<img class="img" src="@/assets/tmp/041.png" alt="" />
						</div>
						<div class="content">
							<div class="title">一站式应对全球碳</div>
							<div class="des">平台内置多国碳排放标准和计算模型，一键生成符合欧盟 CBAM、美国《通胀削减法案》等国际要求的碳报告，帮助企业轻松应对全球碳贸易壁垒</div>
						</div>
					</div>
					<div class="right-block">
						<div class="heading">构建行业碳标准体系</div>
						<div class="des">平台主导制定《温室气体 产品碳足迹量化方法与要求 集装箱》等国家标准，统一行业核算规则，为中国集装箱行业参与全球碳治理提供话语权</div>
						<div class="ul">
							<div class="li">
								<div class="icon">
									<svg-icon name="checkbox"></svg-icon>
								</div>
								<div class="text">为政府部门提供行业碳排放大数据监测，支撑政策制定和监管</div>
							</div>
							<div class="li">
								<div class="icon">
									<svg-icon name="checkbox"></svg-icon>
								</div>
								<div class="text">助力集装箱产业绿色转型，推动行业向低碳、循环经济发展，实现 "双碳" 目标</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<Foot></Foot>
	</div>
</template>

<script>
	import { webInfo } from '@/common/data.js';
	import Head from "@/layout/Head/Head.vue";
	import Foot from '@/layout/Foot/Foot.vue';
	import { WOW } from 'wowjs';
	export default {
		name: 'yzsdglfw',
		components: { Head, Foot },
		data() {
			return {
				youshiInfo: webInfo.pingtaiyoushi[0]
			}
		},
		created() {},
		mounted() {
			this.$nextTick(() => {
				new WOW({
					boxClass: 'wow',
					animateClass: 'animate__animated',
					offset: 100,
					mobile: true,
					live: true,
					// callback: function (c) {
					//     console.log(c, 'sss')
					// },
					scrollContainer: null,
					resetAnimation: true
				}).init();
			});
		},
		methods: {
			backHead() {
				this.$router.go(-1);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.yzsdglfw-page {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		position: relative;
		.banner {
			// margin-top: -$head-height;
			// background-image: url('~@/assets/tmp/027.png');
			background-size: cover;
			height: 233px;
			background-color: #29965C;
			.content {
				display: flex;
				flex-direction: column;
				padding-left: 50px;
				padding-right: 50px;
				box-sizing: border-box;
				.heading {
					margin-top: 87px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 36px;
					color: #ffffff;
					line-height: 52px;
					text-align: center;
				}
				.des {
					margin-top: 17px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 18px;
					color: #ffffff;
					line-height: 22px;
					text-align: center;
				}
			}
		}
		.section-1 {
			background-color: #FFFFFF;
			padding-top: 63px;
			padding-bottom: 63px;
			.section-container {
				display: flex;
				flex-direction: column;
				.heading {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 34px;
					color: #000000;
					line-height: 52px;
				}
				.des {
					margin-top: 25px;
					width: 560px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 17px;
					color: #262729;
					line-height: 24px;
				}
				.ul {
					margin-top: 40px;
					display: flex;
					justify-content: space-between;
					.li {
						// margin-left: 35px;
						display: flex;
						align-items: center;
						width: 155px;
						height: 106px;
						background: #FFFFFF;
						border: 1px solid #DFDFDF;
						box-sizing: border-box;
						border-radius: 10px;
						&:nth-child(1) {
							// margin-left: 0;
							.square {
								background: #20BFA9;
							}
						}
						&:nth-child(2) {
							.square {
								background: #FF794D;
							}
						}
						&:nth-child(3) {
							.square {
								background: #1787FC;
							}
						}
						&:nth-child(4) {
							.square {
								background: #FFCD28;
							}
						}
						&:nth-child(5) {
							.square {
								background: #9447F5;
							}
						}
						&:nth-child(6) {
							.square {
								background: #A98A6C;
							}
						}
						&:nth-child(7) {
							.square {
								background: #6ea952;
							}
						}
						.square {
							margin-left: 30px;
							width: 24px;
							height: 24px;
							border-radius: 4px;
						}
						.label {
							margin-left: 30px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 21px;
							color: #262729;
							line-height: 29px;
						}
					}
				}
			}
		}
		
		.section-2 {
			background: #F9FAFB;
			padding-top: 81px;
			padding-bottom: 74px;
			.section-container {
				display: flex;
				flex-direction: column;
				.heading {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 34px;
					color: #000000;
					line-height: 52px;
				}
				.ul {
					margin-top: 47px;
					display: flex;
					justify-content: space-between;
					.li {
						width: 401px;
						min-height: 249px;
						background: #FFFFFF;
						border: 1px solid rgba(223,223,223,0.7);
						padding: 26px 32px;
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						border-radius: 10px;
						.provide {
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 15px;
							color: rgba(#262729, 0.7);
							line-height: 21px;
						}
						.label {
							margin-top: 22px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 24px;
							color: #262729;
							line-height: 33px;
						}
						.des {
							margin-top: 31px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 14px;
							color: #A4A6AA;
							line-height: 20px;
							text-align: justify;
						}
					}
				}
			}
		}
		
		.section-3 {
			background: #FFFFFF;
			padding-top: 64px;
			padding-bottom: 196px;
			.section-container {
				display: flex;
				.left-block {
					width: 429px;
					min-height: 515px;
					background: #FFFFFF;
					box-shadow: 0px 24px 60px 0px rgba(0,0,0,0.1);
					display: flex;
					flex-direction: column;
					
					&:hover {
						.content {
							.title {
								color: #29965c;
							}
						}
					}
					.cover {
						width: 100%;
						height: 243px;
						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}
					.content {
						flex: 1;
						padding-top: 40px;
						padding-left: 50px;
						padding-right: 50px;
						padding-bottom: 40px;
						// border: 1px solid #e7e7e7;
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						.title {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 24px;
							color: #262729;
							line-height: 33px;
						}
						.des {
							flex: 1;
							margin-top: 28px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 17px;
							color: #262729;
							line-height: 24px;
							text-align: justify;
						}
					}
				}
				
				.right-block {
					flex: 1;
					padding-left: 123px;
					padding-right: 18px;
					padding-top: 68px;
					display: flex;
					flex-direction: column;
					.heading {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 30px;
						color: #262729;
						line-height: 42px;
					}
					.des {
						margin-top: 21px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 17px;
						color: rgba(#262729, 0.7);
						line-height: 24px;
						text-align: justify;
					}
					.ul {
						margin-top: 50px;
						display: flex;
						flex-direction: column;
						.li {
							margin-top: 43px;
							display: flex;
							align-items: center;
							.icon {
								margin-right: 21px;
								.svg-icon {
									width: 20px;
									height: 20px;
									display: block;
								}
							}
							.text {
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 18px;
								color: #262729;
								line-height: 25px;
								text-align: justify;
							}
						}
					}
				}
			}
		}
		
		.section-4 {
			background: #F3F7FE;
			padding-top: 81px;
			padding-bottom: 74px;
			.section-container {
				display: flex;
				flex-direction: column;
				.heading {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 34px;
					color: #000000;
					line-height: 52px;
				}
				.section-pic {
					display: flex;
					justify-content: center;
					.img {
						width: 1017px;
						height: 672px;
						margin: 16px auto 0;
					}
				}
			}
		}
	}
</style>